export const isMobileViewport = (): boolean =>
  window.visualViewport.width < 640;

export const isRunningInTheApp = (): boolean => window.MobileApp;
